import React, { Component } from "react";
import Modal from "react-modal";
import axios from "axios";
import "../common.css";
import Select from "react-select";
import LoadingPage from "../../components/Loading/Loading";
import config from "../../config";
import errorFunctions from "../../store/errorFunctions";
import "./StaffAdd.css";

import utilityFunctions from "../../store/utilityFunctions";
import { MdClose } from "react-icons/md";
import SelectOption from "@components/Select/SelectOption";
Modal.setAppElement("body");

const roleOptions = [
  { label: "Commercial Admin", value: "Commercial Admin" },
  { label: "Commercial Staff", value: "Commercial Staff" },
];

const accessLevelOptions = [
  { label: "No Access", value: "no_access" },
  { label: "Access", value: "partial" },
];

export default class StaffEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isLoading: false,
      details: this.props.user,
      id: null,
      showApproveModal: false,
      showDeclineModal: false,
      addComment: "",
      startPostageNumber: "",
      endPostageNumber: "",
      showDeleteModal: false,
      redirect: false,
      showOutOfWarrantyModal: false,
      showAddNote: false,
      addedNote: "",
      employee: null,
      ticketID: null,
      employeeID: null,
      showAssignModal: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: this.props.user.user_role,
      name: "",
      email: "",
      storeLocationValue: this.props.user.store_location
        ? {
            label:
              this.props.user.seller.name +
              " - " +
              this.props.user.store_location.name,
            value: this.props.user.store_location.id,
          }
        : null,
      storeLocationId: this.props.user.store_location
        ? this.props.user.store_location.id
        : "",
      storeLocationChanged: false,
      cin7AccessLevel: this.props.user.cin7_access || "no_access",
      currentStoreLocationId: this.props.user.store_location?.id || "",
    };
  }

  componentDidMount() {
    this.retriveAllBrand();
    // this.retriveAllRoles();
    // this.retrieveStoreLocation();
  }

  // retrieveStoreLocation = () => {
  //   this.setState({
  //     isLoading: true,
  //     // deviceId: brandDevice[0]?.id,
  //   });
  //   this.props
  //     .protectedFetch(
  //       config.backendServer + "store_location/dropdown/",
  //       "GET",
  //       { brand_id: utilityFunctions.getCookie("brandId") || "" },
  //       errorFunctions.checkResponseThenJson
  //     )
  //     .then((res) => {
  //       const options = res.map((r) => {
  //         return { label: r.combine_name, value: r.id };
  //       });

  //       this.setState({
  //         isLoading: false,
  //         locationOptions: [...[{ label: "---", value: "" }], ...options],
  //       });
  //       this.retrieveStore(res[0].id);
  //     })
  //     .catch((err) => {
  //       this.setState({
  //         isLoading: false,
  //       });
  //       console.log(err);
  //     });
  // };
  // retriveDetailStaff = (id) => {
  //   this.setState({ loading: true });
  //   this.props
  //     .protectedFetch(config.backendServer + "employee/" + id + "/", "GET", { id }, errorFunctions.checkResponseThenJson)
  //     .then((res) => {
  //       this.setState({ loading: false, details: res, currentRole: res.user_role });
  //     })
  //     .catch(() => {
  //       console.log("fail");
  //       this.setState({ loading: false });
  //     });
  // };

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };
  deleteUserLocation = () => {
    let url = `${config.backendServer}store_location/${this.state.currentStoreLocationId}/remove_staff/${this.state.details.id}/`;
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      console.log(response.status);
      if (response.status === 204) {
        this.setState({ showConfirmDelete: false, loading: false });
        if (this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
      } else if (response.status === 406) {
        alert(
          `Delete is not allowed, User Service Center is already linked to ticket`
        );
      } else if (response.status === 409) {
        alert(`User Service does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };
  addUserLocation = (userId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: this.state.details.id,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${this.state.storeLocationId}/add_staff/`,
        payload,
        options
      )
      .then(() => {
        // let tempUsers = [...this.state.data];
        // tempUsers.push(res.data);
        this.setState({ loading: false, showAddUser: false, employeeID: "" });
        this.props.retrieveStaffs();
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
  };
  handleSubmit = (e) => {
    e.preventDefault();

    if (
      this.state.cin7AccessLevel === "partial" &&
      !this.state.storeLocationId &&
      !this.props.user.store_location?.id &&
      this.props.isInsertCin7
    ) {
      alert("Please assign a Store Location when granting Cin7 access");
      return;
    }

    this.setState({ loading: true });

    const id = this.props.user.id;
    const selectedBrandIds = Array.from(
      document.querySelectorAll("input[type='checkbox']:checked")
    ).map((checkbox) => parseInt(checkbox.value));

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name ? this.state.name : this.state.details.name,
      email: this.state.email ? this.state.email : this.state.details.email,
      user_role: this.state.currentRole
        ? this.state.currentRole
        : this.state.details.user_role,
    };

    if (this.props.isInsertCin7) {
      payload.cin7_access = this.state.cin7AccessLevel;
    }

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PUT",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        if (
          this.state.storeLocationChanged &&
          this.state.currentStoreLocationId
        )
          this.deleteUserLocation();
        else if (this.state.storeLocationChanged && this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
        else
          this.props.retrieveStaffs();
        this.setState({
          name: "",
          email: "",
          currentRole: "",
          loading: false,
          redirect: true,
        });
        this.props.closeModal();
      })
      .catch(() => {
        console.log("fail");
      });
  };
  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  render() {
    if (this.state.loading) {
      return <LoadingPage />;
    }

    const details = this.props.user || {};

    return (
      <div className="card" style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <button
          onClick={this.props.closeModal}
          className={"confirm-modal-close"}
        >
          <MdClose />
        </button>
        <h4 className={"card-header"}>{details.name}</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>
                Full name:
              </label>
              <input
                type="text"
                id="name"
                required={true}
                defaultValue={details.name || this.state.fullName}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Email:</label>
              <input
                type="email"
                id="email"
                required={true}
                defaultValue={details.email || this.state.email}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Brands:</label>
              <span>
                {this.state.brands.map((brand) => (
                  <div className="col-6" key={brand.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`brand-${brand.id}`}
                        defaultChecked={this.state.details.brands.some(
                          (activeBrand) => activeBrand.id === brand.id
                        )}
                        value={brand.id}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`brand-${brand.id}`}
                      >
                        {brand.name}
                      </label>
                    </div>
                  </div>
                ))}
              </span>
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Role:</label>
              <Select
                required
                options={roleOptions}
                value={roleOptions.find(
                  (x) => x.value === this.state.currentRole
                )}
                placeholder="Select Role"
                onChange={(e) => {
                  this.setState({
                    currentRole: e.value,
                  });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>
                Store Location<span>:</span>
              </label>
              <SelectOption
                apiEndpoint={config.backendServer + "store_location/dropdown/"}
                placeholder="Select Location"
                value={this.state.storeLocationValue}
                onChange={(e) => {
                  this.setState({
                    storeLocationValue: e,
                    storeLocationId: e?.value || "",
                    storeLocationChanged:
                      this.state.currentStoreLocationId !== e?.value,
                  });
                }}
                additionalParams={{
                  brand_id: utilityFunctions.getCookie("brandId") || "",
                }}
                formatLabel={(item) => item.combine_name}
              />
            </div>

            {this.props.isInsertCin7 && (
              <div className={"single-warranty-details-item"}>
                <label className={"single-warranty-details-label"}>
                  Cin7 Access<span>:</span>
                </label>
                <Select
                  required
                  options={accessLevelOptions}
                  value={accessLevelOptions.find(
                    (x) => x.value === this.state.cin7AccessLevel
                  )}
                  placeholder="Select Cin7 Access"
                  onChange={(e) => {
                    this.setState({
                      cin7AccessLevel: e.value,
                    });
                  }}
                />
              </div>
            )}
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="col-3">
                <button className={"btn btn-outline-primary"} type="submit">
                  Save
                </button>
              </div>
              <div className="col-3">
                <button
                  className={"btn btn-outline-secondary"}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
